module.exports = __webpack_public_path__ + "static/media/senseview-2.32e6bf9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/section-images/senseview-2.png
// module id = 92
// module chunks = 0